import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, LazyAction, type LazyComponent } from 'owa-bundling';
import { getStore } from './store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "TestService" */ './lazyIndex'),
    { name: 'TestService' }
);

// Delay loaded components
export const TestService: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.TestService,
    undefined,
    undefined,
    { onlyImportIf: () => getStore().showTestService }
);

export const lazySetShowTestService: LazyAction<
    typeof lazyIndex.setShowTestService,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setShowTestService);
